import { FC } from 'react';
import { Box } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ColumnItem, { ColumnItemProps } from './ColumnItem';

type SortableColumnItemProps = Omit<ColumnItemProps, 'dragHandleProps'>;

const SortableColumnItem: FC<SortableColumnItemProps> = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.id,
  });

  return (
    <Box
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        position: 'relative',
        zIndex: isDragging ? 1 : 'auto',
      }}
    >
      <ColumnItem {...props} dragHandleProps={{ ...attributes, ...listeners }} />
    </Box>
  );
};

export default SortableColumnItem;
